export default "__VITE_ASSET__BCFTTgMX__"